import { useState } from 'react';
import AdminUsers from './AdminUsers';
import AdminScripts from './AdminScripts';
import AdminRecovery from './AdminRecovery';
import CommissionAdmin from './CommissionAdmin';

const TABS = ['Users', 'Scripts & Promos', 'Recovery', 'Commission'];

export default function AdminModule({ initialTab = 'Users' }) {
  const [tab, setTab] = useState(initialTab);

  return (
    <div className="module-page">
      <div className="module-header">
        <span style={{ fontSize: 22 }}>⚙️</span>
        <h1 className="module-title">Admin</h1>
      </div>
      <div className="module-tabs">
        {TABS.map(t => (
          <button
            key={t}
            className={`module-tab ${tab === t ? 'active' : ''}`}
            onClick={() => setTab(t)}
          >
            {t}
          </button>
        ))}
      </div>
      {tab === 'Users'           && <AdminUsers />}
      {tab === 'Scripts & Promos' && <AdminScripts />}
      {tab === 'Recovery'        && <AdminRecovery />}
      {tab === 'Commission'      && <CommissionAdmin />}
    </div>
  );
}
